import type { PayloadAction } from '@reduxjs/toolkit';

import { APP_INFO } from '@ricoh/ria.client.core/constants/core/app';
import createBrowserStorage from '@ricoh/ria.client.core/plugins/storage/browser';

import type { ProfileSettings } from '~/common/model/api/batch';

import type { SourceSettingsState } from './_state.type';

import { sourceSettingsState } from './_state';

const scannerStore = createBrowserStorage<string>('local', APP_INFO.WEB.STORAGE.NAME, APP_INFO.WEB.STORAGE.STORE.PROCESS.SOURCE_SETTINGS.SCANNER);

/** SourceSettings Reducer. */
export const sourceSettingsReducer = {
  /**
   * SourceSettings setProfiles.
   *
   * @param {SourceSettingsState} state State.
   * @param {PayloadAction<ProfileSettings | undefined>} action Action.
   */
  sourceSettings_setProfiles: (state: SourceSettingsState, { payload }: PayloadAction<ProfileSettings | undefined>) => {
    state.sourceSettings.profiles = payload ?? sourceSettingsState.sourceSettings.profiles;
  },

  /**
   * SourceSettings setScanningProfile.
   *
   * @param {SourceSettingsState} state State.
   * @param {PayloadAction<ProfileSettings['scanning']>} action Action.
   */
  sourceSettings_setScanningProfile: (state: SourceSettingsState, { payload }: PayloadAction<ProfileSettings['scanning']>) => {
    state.sourceSettings.profiles.scanning = payload;
  },

  /**
   * SourceSettings setSeparationProfile.
   *
   * @param {SourceSettingsState} state State.
   * @param {PayloadAction<ProfileSettings['scanning']>} action Action.
   */
  sourceSettings_setSeparationProfile: (state: SourceSettingsState, { payload }: PayloadAction<ProfileSettings['separation']>) => {
    state.sourceSettings.profiles.separation = payload;
  },

  /**
   * SourceSettings setScanner.
   *
   * @param {SourceSettingsState} state State.
   * @param {PayloadAction<string | undefined>} action Action.
   */
  sourceSettings_setScanner: (state: SourceSettingsState, { payload }: PayloadAction<string | undefined>) => {
    state.sourceSettings.scanner = payload ?? '';

    scannerStore.set(state.sourceSettings.scanner);
  },

  /**
   * SourceSettings setScannerData.
   *
   * @param {SourceSettingsState} state State.
   * @param {PayloadAction<string[]>} action Action.
   */
  sourceSettings_setScannerData: (state: SourceSettingsState, { payload }: PayloadAction<string[]>) => {
    state.sourceSettings.scannerData = payload;
  },
};
